import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection, EditerBox, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import {CustomPopup, LoadingBox, RentConditionPopup} from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { CustomSelect, InputBoxCol2, InputItemBox } from "component/basic/formItems";
import {arrParam, birthdaySet, comFormat, datePramaSet, getDateGap, setDateTime} from "js/function";
import { CarDetailItem } from "component/product/car";
import { FixedPage, FixedSection } from "component/basic";
import { IconInfoText } from "component/app/subItem";
import { NotItems } from "component/basic/notItems";
import { ChkSelect, Tap } from "component/basic/tap";
import { AddProductItem, AddProductListBox, AddProductListItem, CarDetailAnnouncementBox, CarDetailAnnouncementTextBox, CarDetailControllBox, CarDetailSection, CarDetailSectionSubTitle, CarDetailTextArea, CarRentInsuranceItem, CarSetInfoItem, CarSetInfoSection, CarSetInfoSlideSection, FixedContents, PopupCaptionTextBox, PopupCaptionTextItem } from "component/product/page";
import {MainDataArea} from "../../component/main/items";
import {DateSelectPopup, InsurancePopup} from "../popup/Popup";

const RentReservation = (props) => {
    const navigate = useNavigate();

    const location = useLocation();
	const locationData = location?.state ? location?.state : null;
	const filterSettingData = locationData?.filterData;
    const cCode = locationData?.cCode;
    const mCode = locationData?.mCode;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const [btnChk,setBtnChk] =  useState(true);
    const [submitChk,setSubmitChk] =  useState(true);

    const [filter,setFilter] =  useState({
        addr:"제주국제공항",
        startDtm:filterSettingData?.startDtm,
        endDtm:filterSettingData?.endDtm,
        birth:null,
        career:2,
        carCategory:[],
        insuranceId:"",
        insuranceName:"고급자차",
        order:"low_price",
        search:null,
        keyword:null,
        size:null,
        appearance:null,
        maker:null,
        fuel:null,
        year:null,
        option:null,
        drivingMethod:null,
        is_outsourcing: null
    });

    const [paymentData,setPaymentData] = useState({
        company_mapped_code:cCode,
        model_mapped_code:mCode,
        start_date:filterSettingData?.startDtm,
        end_date:filterSettingData?.endDtm,
        reservation_name:null,
        reservation_phone:null,
        reservation_email:null,

        birthday:null,
        phoneType:null,
        gender:"m",

        code:null,

        driver_name:null,
        driver_birth:null,
        driver_phone:null,
        driver_license:null,
        driver_career:null,

        insurance_id:null,

        add_product:[]
    });

    const [isDuplicate, setIsDuplicate] =  useState(0);

    const [emailErr,setEmailErr] =  useState(null);

    const [cetified,setCetified] =  useState("");
    const [certifyErr,setCertifyErr] =  useState(null);
    const [timerCount,setTimerCount] =  useState("3:00");
    const [cetifiedChk,setCetifiedChk] =  useState(false);
    const [cetifiedComChk,setCetifiedComChk] =  useState(false);

    const [cetifiedBtnChk,setCetifiedBtnChk] =  useState(true);

    const [alertPopupData,setAlertPopupData] =  useState(null);

    const [tempFilter,setTempFilter] =  useState(null);
    const [conditionPopupData,setConditionPopupData] =  useState(null);
    const [dateSelectPopupData,setDateSelectPopupData] =  useState(null);
    const [filterPopupData,setFilterPopupData] =  useState(null);
    const [searchKey,setSearchKey] =  useState(null);
    const [insurancePopupData,setInsurancePopupData] =  useState(null);

    const rentDay = filterSettingData ? getDateGap(filterSettingData?.startDtm,filterSettingData?.endDtm,"day") : 0;

    const pageDataApi = useGet({
        url:`/reservation/car/detail?company_mapped_code=${cCode}
        &model_mapped_code=${mCode}
        &review_order=${"desc"}
        &start_date=${filterSettingData?.startDtm ? datePramaSet(filterSettingData?.startDtm) : ""}
        &end_date=${filterSettingData?.endDtm ? datePramaSet(filterSettingData?.endDtm) : ""}
        &birth=${filterSettingData?.birth||""}
        &career=${filterSettingData?.career||""}
        ${arrParam(filterSettingData?.carCategory,"type[]",false,"id")}
        &search=${filterSettingData?.search||""}
        &insurance_id=${(paymentData?.insurance_id ? paymentData?.insurance_id : filterSettingData?.insuranceId)||""}
        &order=${filterSettingData?.order||""}
        ${arrParam(filterSettingData?.keyword,"keyword[]")}
        ${arrParam(filterSettingData?.size,"size[]")}
        ${arrParam(filterSettingData?.appearance,"appearance[]")}
        ${arrParam(filterSettingData?.maker,"maker[]")}
        ${arrParam(filterSettingData?.fuel,"fuel[]")}
        ${arrParam(filterSettingData?.year,"year[]")}
        ${arrParam(filterSettingData?.option,"option[]")}`,
        loginType:"login"
    });
    const pageData = pageDataApi?.data;
    const carData = pageData?.car;

    const insuranceApi = useGet({
        url:`/insurance`,
        loginType:"login"
    });
    const insuranceData = insuranceApi?.data?.insurances;

    const filterTypeDataApi = useGet({
        url:`/data/type?type=차종`,
        loginType:"login"
    });
    const filterTypeData = filterTypeDataApi?.data?.datas;

    const [firstSet,setFirstSet] =  useState(true);

    const [insuranceSel,setInsuranceSel] =  useState(null);

    const categoryApi = useGet({
        url:`/add/product/category`,
        loginType:"login"
    });
    const categoryData = categoryApi?.data?.add_product_categories;

    const [categoryId,setCategoryId] =  useState(null);

    const addProductApi = useGet({
        url:categoryId ? `/add/product?category_id=${categoryId}` : null,
        loginType:"login"
    });
    const addProductData = addProductApi?.data?.add_products;

    const addProductInfoApi = useGet({
        url:`/info/add/product`,
        loginType:"login"
    });
    const addProductInfoData = addProductInfoApi?.data?.add_product_information;

    const [addProductItem,setAddProductItem] =  useState([]);
    const [addProductSelItem,setAddProductSelItem] =  useState([]);

    const [addProductPopup,setAddProductPopup] =  useState(null);

    const [addTotalPrice,setAddTotalPrice] =  useState(0);
    const [addTotalQty,setAddTotalQty] =  useState(0);
    const [addTotalPriceSel,setAddTotalPriceSel] =  useState(0);

    const myInfoApi = useGet({
        url:localStorage.getItem("token") ? `/mypage/account` : null,
        loginType:"login"
    });
    const myInfoData = myInfoApi?.data?.user_info;

    const [carInformationPopup,setCarInformationPopup] =  useState(null);

    function insurancePopupOpen() {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;

        setInsurancePopupData({
            addClass: null,
            title: "자차보험 선택",
            closeType: true,
            closeFunc: (e) => {
                setInsurancePopupData(null)
            }
        });
    }

    function tempFilterDataCh(key,val){
        let oldData = {...tempFilter};
        oldData[key] = val;
        setTempFilter(oldData);

        if(key === "search"){
            setSearchKey(null);
        }
    }

    function dateSelectPopupOpen(){
        setDateSelectPopupData({
            addClass:"topPopup",
            title:"대여/반납 일시 선택",
            closeType:true,
            closeFunc:(e) => {setDateSelectPopupData(null)}
        });
    }

    function addProductQtyFunc(item,qty){
        let oldSelItem = [...addProductSelItem];
        let oldItem = [...addProductItem];

        if(qty == 0){
            oldSelItem = oldSelItem?.filter((el)=>el.id !== item.id);
        }else{
            if(oldSelItem?.filter((el)=>el.id === item.id)?.length > 0){
                oldSelItem = oldSelItem?.map((subItem) => subItem.id === item.id ? 
                    {
                        ...subItem,
                        qty: qty
                    } 
                : subItem)
            }else{
                oldSelItem.push({
                    ...item,
                    qty: qty
                })
            }
        }

        setAddProductSelItem(oldSelItem);

        if(oldItem?.filter((el)=>el.id === item.id)?.length > 0){
            oldItem = oldItem?.map((subItem) => subItem.id === item.id ? 
                {
                    ...subItem,
                    qty: qty
                } 
            : subItem)
        }else{
            oldItem.push({
                ...item,
                qty: qty
            })
        }

        setAddProductItem(oldItem);
    }

    function addProductFunc(){
        let selItem = [...addProductSelItem];
        paymentDataCh("add_product",selItem);
    }

    const sval = useRef(null);
    function timerStart(){
        //타이머
        setTimerCount("3:00");
        setCertifyErr("");
        
        if (sval.current !== null) {
            clearInterval(sval.current);
            sval.current = null;
        }
        
        timerChk(2.99);
    
        function timerChk(duration) {
            let timerNumber = duration * 60;
            let m, s;
            sval.current = setInterval(function() {
                m = parseInt(timerNumber / 60 % 60, 10);
                s = parseInt(timerNumber % 60, 10);
                s = s < 10 ? "0" + s : s;
    
                setTimerCount(m + ":" + s);
    
                if (--timerNumber < 0) {
                    timerNumber = 0;
                    clearInterval(sval.current);
                    sval.current = null;
                    setCertifyErr("인증시간이 초과되었습니다.");
                    setCetifiedComChk(true);
                    setCetified("");
                }
            }, 1000);
        }
    }
    
    function cetifiedStert(){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);

            let formData = new FormData();
            formData.append("name", paymentData?.reservation_name);
            formData.append("birth", paymentData?.birthday ? birthdaySet(String(paymentData?.birthday).replace(/\./g,""),paymentData?.gender) : "");
            formData.append("phone", paymentData?.reservation_phone && paymentData?.reservation_phone?.replace(/\-/g,""));
            formData.append("mobile_carrier", paymentData?.phoneType.val);
    
            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: null,
                url: `/certification`,
                success: (apiData) => {
                    setSubmitChk(true);
    
                    timerStart();
                    setCetified("");
                    setCetifiedChk(true);
                    setLoadingBoxOpen(false);
        
                    paymentDataCh("code",apiData?.data?.response_seq||"123123");
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    function cetifiedEnd(){
        if(submitChk){
            if(cetifiedChk){
                setSubmitChk(false);
                setLoadingBoxOpen(true);

                let formData = new FormData();

                formData.append("name", paymentData?.reservation_name);
                formData.append("birth", paymentData?.birthday ? birthdaySet(String(paymentData?.birthday).replace(/\./g,""),paymentData?.gender) : "");
                formData.append("phone", paymentData?.reservation_phone && paymentData?.reservation_phone?.replace(/\-/g,""));
                formData.append("mobile_carrier", paymentData?.phoneType.val);

                formData.append("response_seq", paymentData?.code);
                formData.append("certification_code", cetified);

                fatchSet.FatchApi({
                    type:"POST",
                    formDataItem: formData,
                    loginType: null,
                    url: `/certification/check`,
                    success: (apiData) => {
                        setSubmitChk(true);

                        setCetifiedComChk(true);

                        setTimerCount("3:00");
                        setCertifyErr("");

                        clearInterval(sval.current);
                        sval.current = null;

                        setLoadingBoxOpen(false);
                    },
                    err: (apiData) => {
                        setSubmitChk(true);
                        if(apiData.alert){
                            setCertifyErr(apiData.alert);
                        }
                        setLoadingBoxOpen(false);
                    }
                })
            }else{
                cetifiedStert();setCetifiedComChk(false);setCetified("")
            }
        }
    }

    function paymentDataCh(key,val){
        let oldData = {...paymentData};
        oldData[key] = val;
        setPaymentData(oldData);

        setIsDuplicate((oldData.driver_name === oldData.reservation_name && oldData.reservation_phone === oldData.driver_phone && oldData.birthday === oldData.driver_birth) ? 1 : 0)
    }

    useEffect(() => {
        if (filter) {
            setTempFilter(filter)
        }
    }, [filter])

    useEffect(() => {
        let oldData = {...paymentData};

        if(filterSettingData){
            oldData.start_date = filterSettingData?.startDtm;
            oldData.end_date = filterSettingData?.endDtm;

            if(carData?.car_insurances && carData?.car_insurances?.filter((el)=>el.id == filterSettingData?.insuranceId)?.length){
                oldData.insurance_id = filterSettingData?.insuranceId;
                setInsuranceSel(carData?.car_insurances?.filter((el)=>el.id == filterSettingData?.insuranceId)[0]);
            }

            if(filterSettingData?.career || filterSettingData?.career == 0){
                oldData.driver_career = filterSettingData?.career;
            }

            setPaymentData(oldData);
        }else{
            navigate("/pageErr");
        }
    }, []);

    useEffect(() => {
        let oldData = {...paymentData};
        
        if(pageData){
            setLoadingBoxOpen(false);

            if(filterSettingData && firstSet){
                setFirstSet(false);
                
                oldData.start_date = filterSettingData?.startDtm;
                oldData.end_date = filterSettingData?.endDtm;
    
                if(carData?.car_insurances && carData?.car_insurances?.filter((el)=>el.id == filterSettingData?.insuranceId)?.length){
                    oldData.insurance_id = filterSettingData?.insuranceId;
                    setInsuranceSel(carData?.car_insurances?.filter((el)=>el.id == filterSettingData?.insuranceId)[0]);
                }
    
                if(filterSettingData?.career || filterSettingData?.career == 0){
                    oldData.driver_career = filterSettingData?.career;
                }
    
                setPaymentData(oldData);
            }
        }
    }, [pageDataApi]);

    useEffect(() => {
        setTimeout(() => {
            setLoadingBoxOpen(false);
        }, 2000);
    }, []);

    useEffect(() => {
        if(categoryData && categoryData?.length > 0){
            setCategoryId(categoryData[0]?.id);
        }
    }, [categoryApi]);

    useEffect(() => {
        if(addProductData){
            let newData = [...addProductData];
            let selData = [...paymentData?.add_product];

            newData = newData?.map((subItem) => selData?.filter((el)=>el.id === subItem.id)?.length > 0 ? 
                {
                    ...subItem,
                    qty: selData?.filter((el)=>el.id === subItem.id)[0].qty
                } 
            : 
                {
                    ...subItem,
                    qty: 0
                }
            )

            setAddProductItem(newData);
        }
    }, [addProductApi]);

    useEffect(() => {
        let total = 0;
        let qty = 0;

        addProductSelItem?.forEach(function(item,i){
            total = total + (item.price * item.qty * rentDay);
            qty = qty + item.qty;

            if(addProductSelItem?.length - 1 === i){
                setAddTotalPrice(total);
                setAddTotalQty(qty);
            }
        })

        if(addProductSelItem?.length <= 0){
            setAddTotalPrice(0);
            setAddTotalQty(0);
        }
    }, [addProductSelItem]);

    useEffect(() => {
        if(myInfoData && localStorage.getItem("token")){
            let oldData = {...paymentData};
            oldData.birthday = myInfoData.birth;
            oldData.reservation_name = myInfoData?.name;
            oldData.reservation_phone = myInfoData?.phone;
            oldData.reservation_email = myInfoData?.email;

            setPaymentData(oldData);
        }
    }, [myInfoApi]);

    useEffect(() => {
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        let regEmail = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,4}$/i
        
        let total = 0;

        paymentData?.add_product?.forEach(function(item,i){
            total = total + (item.price * item.qty * rentDay);

            if(paymentData?.add_product?.length - 1 === i){
                setAddTotalPriceSel(total);
            }
        });

        if(paymentData?.reservation_email?.length > 0 && !regEmail.test(paymentData?.reservation_email)){
            setEmailErr("정확한 이메일을 입력해주세요");
        }else{
            setEmailErr(null);
        }
        
        if(paymentData?.company_mapped_code
        && paymentData?.model_mapped_code
        && paymentData?.start_date
        && paymentData?.end_date
        && paymentData?.reservation_name && paymentData?.reservation_name.length > 0
        && paymentData?.birthday && ragChk.test(paymentData?.birthday.replace(/\./g,""))
        && paymentData?.reservation_phone && phoneChk.test(paymentData?.reservation_phone?.replace(/\-/g,""))
        && paymentData?.reservation_email && regEmail.test(paymentData?.reservation_email)     
        && (localStorage.getItem("token") ? true : (cetifiedComChk && paymentData?.code))
        && paymentData?.driver_name && paymentData?.driver_name.length > 0 
        && paymentData?.driver_birth && ragChk.test(paymentData?.driver_birth.replace(/\./g,""))
        && paymentData?.driver_phone && phoneChk.test(paymentData?.driver_phone?.replace(/\-/g,""))
        && paymentData?.driver_license
        && paymentData?.driver_career
        && paymentData?.insurance_id){
            setBtnChk(false);
        }else{
            setBtnChk(true);
        }

        if(!localStorage.getItem("token")
        && paymentData?.reservation_name && paymentData?.reservation_name?.length > 0
        && paymentData?.reservation_phone && phoneChk.test(paymentData?.reservation_phone?.replace(/\-/g,""))
        && paymentData?.gender
        && paymentData?.phoneType
        && paymentData?.phoneType.val
        && paymentData?.birthday && ragChk.test(paymentData?.birthday.replace(/\./g,""))){
            setCetifiedBtnChk(false);
        }else{
            setCetifiedBtnChk(true);
        }
    }, [paymentData,cetifiedComChk]);


    function setAlertData(){
        let ragChk = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
        let phoneChk = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
        let regEmail = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,4}$/i

        let title = "";
        let subTitle = "";

        if (!paymentData?.reservation_name || paymentData?.reservation_name.length === 0) {
            title = "예약자 성명 입력"
            subTitle = "예약자 성명을 입력해주세요"
        } else if (!paymentData?.birthday || !ragChk.test(paymentData?.birthday.replace(/\./g,""))) {
            title = "예약자 생년월일 입력"
            subTitle = "예약자 생년월일을 입력해주세요"
        } else if (!paymentData?.reservation_phone || !phoneChk.test(paymentData?.reservation_phone?.replace(/\-/g,""))) {
            title = "예약자 휴대폰 번호 입력"
            subTitle = "예약자 휴대폰 번호을 입력해주세요"
        } else if (!paymentData?.reservation_email || !regEmail.test(paymentData?.reservation_email)) {
            title = "예약자 이메일 입력"
            subTitle = "예약자 이메일을 입력해주세요"
        } else if (!paymentData?.driver_name || paymentData?.driver_name.length === 0) {
            title = "운전자 성명 입력"
            subTitle = "운전자 성명을 입력해주세요"
        } else if (!paymentData?.driver_birth || !ragChk.test(paymentData?.driver_birth.replace(/\./g,""))) {
            title = "운전자 생년월일 입력"
            subTitle = "운전자 생년월일을 입력해주세요"
        } else if (!paymentData?.driver_phone || !phoneChk.test(paymentData?.driver_phone?.replace(/\-/g,""))) {
            title = "예약자 휴대폰 번호 입력"
            subTitle = "예약자 휴대폰 번호을 입력해주세요"
        } else if (!paymentData?.driver_career) {
            title = "운전 경력 선택"
            subTitle = "운전 경력을 선택해주세요"
        } else if (!paymentData?.driver_license) {
            title = "면허종류 선택"
            subTitle = "면허종류를 선택해주세요"
        }  else if (!paymentData?.insurance_id) {
            title = "자차 보험 선택"
            subTitle = "자차 보험을 선택해주세요"
        }

        setAlertPopupData({
            addClass:"subTitle_line_0",
            title: title,
            subTitle: subTitle,
            closeType:true,
            closeFunc:(e) => {setAlertPopupData(null)},
            closeBtnDel:true,
        });
    }

    function reservationCheck() {
        if(submitChk){
            setSubmitChk(false);

            let formData = new FormData();
            formData.append("company_mapped_code", paymentData?.company_mapped_code);
            formData.append("model_mapped_code", paymentData?.model_mapped_code);
            formData.append("start_date", paymentData?.start_date);
            formData.append("end_date", paymentData?.end_date);
            formData.append("driver_birth", paymentData?.birthday?.replace(/\./g, ''));
            formData.append("driver_license", paymentData?.driver_license);
            formData.append("driver_career", paymentData?.driver_career);

            fatchSet.FatchApi({
                type:"POST",
                loginType: "login",
                formDataItem: formData,
                url: `/reservation/check`,
                success: (apiData) => {
                    setSubmitChk(true);

                    setCarInformationPopup({
                        addClass:"",
                        title:"예약 전 점검사항",
                        subTitle:null,
                        closeType:true,
                        closeFunc:(e) => {
                            setCarInformationPopup(null)
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);

                    setTempFilter(prev => ({
                        ...prev,
                        birth: paymentData?.birthday,
                        career: paymentData?.driver_career
                    }));

                    setConditionPopupData({
                        closeFunc:(e) => {setConditionPopupData(null)}
                    })
                }
            })
        }
    }

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                mBtn={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"차량 상세"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={0}
                    closeFunc={()=>{}}
                />
                <PageTitle
                    pageBack={()=>{navigate(-1)}}
                    contents="예약 정보 입력"
                />
                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarDetailItem
                            itemType=""
                            sectionTitle="기존 차량 정보"
                            titleAddClass="mItemT"
                            sectionCaptions={["차량 제원 및 옵션은 현장 사정에 따라 다른 옵션으로 구성된 차량이거나 동급차량으로 변경될 수 있습니다."]}
                            status={null}
                            car_image={carData?.image_url}
                            maker={carData?.maker}
                            modelName={carData?.name}
                            passengerNum={carData?.passenger_number}
                            fuelType={carData?.fuel}
                            min_year={carData?.min_year}
                            max_year={carData?.max_year}
                            car_option={carData?.options}
                            carOptionDisable={carData?.non_options}
                            func={()=>{}}
                        />
                        <CarDetailSection 
                            captions={[
                                "위 입력하신 휴대폰 번호와 이메일로  예약확인과 바우처 안내 내용이 발송됩니다.",
                                "잘못된 정보 입력으로 인한 미수신으로 인해 발생되는 불이익은 당사에서 책임지지 않습니다."
                            ]} 
                            title="예약자 정보"
                        >
                            <CarDetailTextArea title={null} addClass="">
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="이름"
                                    placeholder="예약자 성명"
                                    value={paymentData?.reservation_name}
                                    max={18}
                                    regexp={null}
                                    func={(value)=>{paymentDataCh("reservation_name",value)}}
                                    readOnly={cetifiedComChk}
                                />
                                {!localStorage.getItem("token") && !cetifiedComChk ? 
                                <>
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="생년월일"
                                    placeholder="YYYY.MM.DD"
                                    value={paymentData?.birthday}
                                    regexp={/[^0-9\.]/gi}
                                    birthSetting={true}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    max={10}
                                    func={(value)=>{paymentDataCh("birthday",value)}}
                                            
                                    inBtnArr={[
                                        {
                                            val: "m", 
                                            text: "남", 
                                            func: (val)=>{paymentDataCh("gender",val)}
                                        },
                                        {
                                            val: "f", 
                                            text: "여", 
                                            func: (val)=>{paymentDataCh("gender",val)}
                                        }
                                    ]}
                                    inBtnValue={paymentData?.gender}
                                />
                                <CustomSelect
                                    addClass="notName absoluteSel"
                                    inputName="통신사"
                                    placeholder="선택"
                                    value={paymentData?.phoneType?.val}
                                    func={(name,val) => {
                                        let dataSet = {
                                            val:val,
                                            text:name
                                        }
                                        paymentDataCh("phoneType",dataSet)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={[
                                        {id:1,name:"SKT"},
                                        {id:2,name:"KT"},
                                        {id:3,name:"LGU+"},
                                        {id:5,name:"알뜰폰(SKT)"},
                                        {id:6,name:"알뜰폰(KT)"},
                                        {id:7,name:"알뜰폰(LGU+)"}
                                    ]}
                                />
                                </>
                                :
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="생년월일"
                                        placeholder="YYYY.MM.DD"
                                        value={paymentData?.birthday}
                                        regexp={/[^0-9\.]/gi}
                                        birthSetting={true}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        max={10}
                                        func={(value)=>{paymentDataCh("birthday",value)}}
                                        inBtnArr={[
                                            {
                                                val: "m",
                                                text: "남",
                                                func: (val)=>{paymentDataCh("gender",val)}
                                            },
                                            {
                                                val: "f",
                                                text: "여",
                                                func: (val)=>{paymentDataCh("gender",val)}
                                            }
                                        ]}
                                        inBtnValue={paymentData?.gender}
                                    />
                                }
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="휴대폰 번호"
                                    placeholder="010-1234-1234"
                                    value={paymentData?.reservation_phone}
                                    max={13}
                                    phoneSetting={true}
                                    regexp={"number"}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    readOnly={cetifiedComChk}
                                    errMsg={certifyErr}
                                    unit={cetifiedComChk ? "<b class='wbTextColor'>인증완료</b>" : ""}
                                    func={(value)=>{paymentDataCh("reservation_phone",value);setCetifiedChk(false);setCetifiedComChk(false);setCetified("")}}
                                />
                                {cetifiedChk && !localStorage.getItem("token") && !cetifiedComChk ? 
                                    <InputItemBox
                                        inputType={null}
                                        addClass="cetifiedInput"
                                        inputName="인증번호"
                                        placeholder="인증번호 6자리"
                                        value={cetified}
                                        max={6}
                                        readOnly={cetifiedComChk}
                                        cetified={timerCount}
                                        regexp={"number"}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        func={(value)=>{setCetified(value)}}
                                        errMsg={certifyErr}
                                        subBtn="인증번호 재발송"
                                        inputSubFunc={()=>{cetifiedStert();setCetifiedComChk(false);setCetified("")}}
                                    />
                                :""}
                                {!localStorage.getItem("token") && !cetifiedComChk ? 
                                    <BtnItem
                                        addClass="subColor"
                                        disabled={cetifiedBtnChk}
                                        contents={cetifiedChk ? "인증번호 등록" : "인증번호 발송"}
                                        func={() => {
                                            if(cetifiedChk){
                                                cetifiedEnd();
                                            }else{
                                                cetifiedStert();
                                            }
                                        }}
                                    />
                                :""}
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="이메일"
                                    placeholder="예약확인 및 바우처 안내 받을 이메일 주소"
                                    value={paymentData?.reservation_email}
                                    max={30}
                                    regexp={null}
                                    errMsg={emailErr}
                                    func={(value)=>{paymentDataCh("reservation_email",value)}}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection 
                            captions={[
                                "추가 운전자 정보는 현장에서 예약 차량 대여 간 등록 가능합니다."
                            ]}
                            title="운전자 정보"
                            isDuplicate={isDuplicate}
                            setIsDuplicate={setIsDuplicate}
                            paymentData={paymentData}
                            setPaymentData={setPaymentData}
                        >
                            <CarDetailTextArea>
                                <InputBoxCol2>
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="이름"
                                        placeholder="운전자 성명"
                                        value={paymentData?.driver_name}
                                        max={18}
                                        regexp={null}
                                        func={(value)=>{paymentDataCh("driver_name",value)}}
                                    />
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="운전자 생년월일"
                                        placeholder="YYYY.MM.DD"
                                        value={paymentData?.driver_birth}
                                        max={10}
                                        regexp={/[^0-9\.]/gi}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        birthSetting={true}
                                        errMsg={null}
                                        func={(value)=>{paymentDataCh("driver_birth",value)}}
                                    />
                                </InputBoxCol2>
                                <InputBoxCol2>
                                    <CustomSelect
                                        boxAddClass=""
                                        addClass="absoluteSel"
                                        inputName="운전 경력"
                                        placeholder="경력 선택"
                                        value={paymentData?.driver_career}
                                        func={(name,val) => {
                                            paymentDataCh("driver_career",val)
                                        }}
                                        disabled={false}
                                        valKey="id"
                                        nameKey="name"
                                        options={[
                                            {id:1,name:"1년 이상"},
                                            {id:2,name:"2년 이상"},
                                            {id:3,name:"3년 이상"}
                                        ]}
                                    />
                                    <InputItemBox
                                        inputType={null}
                                        addClass=""
                                        inputName="휴대폰 번호"
                                        placeholder="010-1234-1234"
                                        value={paymentData?.driver_phone}
                                        max={13}
                                        phoneSetting={true}
                                        regexp={"number"}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        func={(value)=>{paymentDataCh("driver_phone",value)}}
                                    />
                                </InputBoxCol2>
                                <ChkSelect
                                    title="면허종류 선택"
                                    val={paymentData?.driver_license}
                                    data={[
                                        {
                                            id:"1종보통",
                                            category:"1종 보통"
                                        },
                                        {
                                            id:"1종대형",
                                            category:"1종 대형"
                                        },
                                        {
                                            id:"2종보통",
                                            category:"2종 보통"
                                        },
                                        {
                                            id:"classB",
                                            category:"국제 면허(Class B)"
                                        },
                                        {
                                            id:"classD",
                                            category:"국제 면허(Class D)"
                                        }
                                    ]}
                                    func={(id)=>{paymentDataCh("driver_license",id)}}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection 
                            captions={null}
                            title="자차 보험"
                        >
                            <CarDetailTextArea>
                                {carData?.car_insurances && carData?.car_insurances?.length > 0 ?
                                <>
                                    {carData?.car_insurances && carData?.car_insurances?.map((item,i)=>(
                                        <CarRentInsuranceItem
                                            key={i}
                                            value={paymentData?.insurance_id}
                                            id={item.id}
                                            name={item.name}
                                            func={(id)=>{
                                                paymentDataCh("insurance_id",id);
                                                setInsuranceSel(item);
                                            }}

                                            driving_age={item.min_age}
                                            driving_experience={item.min_career}
                                            price={item.insurance_price}
                                            limit_compensation={item.insurance_limit}
                                            indemnity={item.charge_immunity} 

                                            furlough_compensation_fee={item.rest_price}
                                            single_accident={item.include_single_accident === 1 ? "보장" : "미보장"}
                                            tire_damage_guarantees={item.include_tire_damage === 1 ? "보장" : "미보장"}
                                        />
                                    ))}
                                </>
                                :
                                <NotItems addClass="bigText sectionNotItem" text="이용 가능한 보험이 없습니다."/>}
                            </CarDetailTextArea>
                            <CarDetailTextArea>
                                <IconInfoText
                                    name="<span class='wbTextColor'>자차보험</span>이란?"
                                    text="고객의 실수로 발생한 자차사고에 대해서 임차인과 렌터카 회사의 계약된 약정에 따라 임차임의 책임을 감면해 주는 차량손해면책제도(CDW)입니다."
                                />
                            </CarDetailTextArea>
                            <CarDetailTextArea>
                                <CarDetailAnnouncementBox
                                    boxTitle={`${carData?.company_name||"-"} 종합 보험 안내사항`}
                                    title={carData?.comprehensive_insurance_name||"-"}
                                    subTitle=""
                                >
                                    <CarDetailAnnouncementTextBox
                                        addClass="mCol"
                                        name="대인 보상범위"
                                        text={`${carData?.person_insurance||""}${carData?.person_insurance_etc ? ` (${carData?.person_insurance_etc})` : ""}`}
                                    />
                                    <CarDetailAnnouncementTextBox
                                        addClass="mCol"
                                        name="대물 보상범위"
                                        text={`${carData?.car_insurance||""}${carData?.car_insurance_etc ? ` (${carData?.car_insurance_etc})` : ""}`}
                                    />
                                    <CarDetailAnnouncementTextBox
                                        addClass="mCol"
                                        name="자손 보상범위"
                                        text={`${carData?.self_insurance||""}${carData?.self_insurance_etc ? ` (${carData?.self_insurance_etc})` : ""}`}
                                    />
                                </CarDetailAnnouncementBox>
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection 
                            captions={null}
                            title="부가서비스"
                        >
                            <CarDetailTextArea>
                                {paymentData?.add_product?.length > 0 ? 
                                <>
                                    {paymentData?.add_product && paymentData?.add_product?.map((item,i)=>(
                                        <AddProductItem
                                            key={i}
                                            addClass=""
                                            id={item.id}
                                            img={item.image_url}
                                            category={item.category||"-"}
                                            name={item.name}
                                            price={item.price}
                                            totalPrice={(item.price * item.qty * rentDay)||0}
                                            amount={item.qty}
                                            day={rentDay}
                                        />
                                    ))}
                                </>
                                :
                                <NotItems addClass="bigText sectionNotItem" text="선택된 부가서비스가 없습니다.<br/>아래 부가서비서 선택 버튼으로 필요하신 부가서비스를 함께 예약하세요."/>
                                }
                                <BtnItem
                                    addClass="subColor"
                                    contents={"부가서비스 선택"}
                                    func={() => {
                                        let oldData = [...paymentData?.add_product];
                                        setAddProductSelItem(oldData);

                                        setAddProductPopup({
                                            addClass:"tapInPopup addProductSelPopup",
                                            title:"부가서비스 선택",
                                            subTitle:null,
                                            closeType:true,
                                            closeFunc:(e) => {
                                                setAddProductPopup(null)
                                            }
                                        });
                                    }}
                                />
                                <CarDetailSectionSubTitle title="부가서비스 이용 안내"/>
                                <EditerBox addClass="" data={addProductInfoData}/>
                            </CarDetailTextArea>
                        </CarDetailSection>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <CarDetailControllBox
                            addClass={"nonFixed titleColor"}
                            title={"결제 정보"}
                            subTitle={null}
                        >
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={`차량 대여요금 ${insuranceSel ? "(자차보험 포함)" : ""}`}
                                titleText={`${comFormat((carData?.discount_price ? carData?.discount_price : carData?.original_price)||"0")} 원`}
                            >
                                <CarSetInfoItem
                                    addClass=""
                                    name="예약 시간"
                                    text={filterSettingData?.startDtm && filterSettingData?.endDtm ? `${getDateGap(filterSettingData?.startDtm,filterSettingData?.endDtm,"time",null)} 시간` : null}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name="보험 정보"
                                    text={insuranceSel?.name||"-"}
                                />
                            </CarSetInfoSlideSection>
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={"부가서비스"}
                                titleText={null}
                            >
                                {paymentData?.add_product?.length > 0 ? 
                                <>
                                    {paymentData?.add_product && paymentData?.add_product?.map((item,i)=>(
                                        <CarSetInfoItem
                                            key={i}
                                            addClass=""
                                            name={`${item.name} * ${item.qty}`}
                                            text={`${comFormat((item.price * item.qty * rentDay)||"0")} 원`}
                                        />
                                    ))}
                                </>
                                :""}
                            </CarSetInfoSlideSection>
                            <CarSetInfoSlideSection
                                titleAddClass="mSize"
                                titleName={"대여/반납일시"}
                                titleText={null}
                            >
                                <CarSetInfoItem
                                    key={0}
                                    addClass=""
                                    name={"대여일시"}
                                    text={filterSettingData?.startDtm}
                                />

                                <CarSetInfoItem
                                    key={1}
                                    addClass=""
                                    name={"반납일시"}
                                    text={filterSettingData?.endDtm}
                                />
                            </CarSetInfoSlideSection>

                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass="bSize"
                                    name="총 결제 금액"
                                    text={`<span class='wbTextColor'>${comFormat((Number(addTotalPriceSel) + Number(carData?.discount_price ? carData?.discount_price : carData?.original_price))||0)} 원</span>`}
                                />
                            </CarSetInfoSection>
                            <BtnBox
                                boxType=""
                                addClass={"row2_re mCol2 mFixed"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                                <BtnItem
                                    addClass={`${btnChk ? "disableBtn" : ""}`}
                                    contents={`${comFormat((Number(addTotalPriceSel) + Number(carData?.discount_price ? carData?.discount_price : carData?.original_price))||0)} 원 결제하기<img src="/assets/images/basic/filter_btn_move.svg"/>`}
                                    func={() => {
                                        if (btnChk) {
                                            setAlertData()
                                        } else {
                                            reservationCheck();
                                        }

                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <CustomPopup data={addProductPopup} basicPB={false} mSize={true}>
                <Tap
                    data={categoryData}
                    nameKey={"name"}
                    valKey={"id"}
                    nameCaption={"#"}
                    val={categoryId}
                    func={(name,val)=>{setCategoryId(val)}}
                />
                <AddProductListBox>
                    {addProductItem && addProductItem?.length > 0 ?
                        <>
                            {addProductItem && addProductItem?.map((item,i)=>(
                                <AddProductListItem
                                    key={i}
                                    addClass=""
                                    id={item.id}
                                    img={item.image_url}
                                    category={item.category||"-"}
                                    name={item.name}
                                    price={item.price}
                                    amount={item.amount}
                                    qty={item.qty}
                                    countFunc={(qty)=>{addProductQtyFunc(item,qty)}}
                                />
                            ))}
                        </>
                    :
                        <NotItems addClass="min" text={`조건에 맞는 부가서비스가 없습니다.`}/>
                    }
                </AddProductListBox>
                <PopupCaptionTextBox>
                    <PopupCaptionTextItem
                        name="선택한 부가서비스"
                        text={`${comFormat(addProductSelItem?.length||"0")} 종`}
                    />
                    <PopupCaptionTextItem
                        name="부가서비스 총 수량"
                        text={`${comFormat(addTotalQty||"0")} 개`}
                    />
                    <PopupCaptionTextItem
                        addClass="total"
                        name="총 결제 금액"
                        text={`${comFormat(addTotalPrice||"0")} 원`}
                    />
                </PopupCaptionTextBox>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"부가서비스 선택 완료"}
                        disabled={false}
                        func={() => {
                            addProductFunc();
                            setAddProductPopup(null);
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <CustomPopup data={carInformationPopup} basicPB={false} mSize={true}>
                <EditerBox addClass="" data={carData?.information}/>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"위 내용에 대해 확인했습니다."}
                        disabled={false}
                        func={() => {
                            setCarInformationPopup(null);
                            navigate("/rent/payment",{state: {paymentData:paymentData,carData:carData,addTotalPriceSel:addTotalPriceSel,insuranceSel:insuranceSel,memberCode:{code:cetified,phone:paymentData?.reservation_phone?.replace(/\-/g,"")}}});
                        }}
                    />
                </BtnBox>
            </CustomPopup>

            <CustomPopup data={alertPopupData} toastType={true}>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"확인"}
                        disabled={false}
                        func={() => {
                            setAlertPopupData(null);
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <RentConditionPopup data={conditionPopupData} toastType={true} basicPB={false}>
                <MainDataArea addClass="mainArea mainTopBannerArea">
                    <div className="mainFilterBox" style={{maxWidth: "500px"}}>
                        <div className={"rentFilter_titleArea"}>
                            <h3 className="rentFilter_title">입력하신 운전 경력 및 나이로는 예약이 불가해요.</h3>
                            <h3 className="rentFilter_title">조건에 맞는 차량을 다시 검색해볼까요?</h3>
                        </div>
                        <div className="mainFilter_inputBox">
                            <InputItemBox
                                inputType={null}
                                addClass=""
                                inputName="<img src='/assets/images/icon/main_filter_icon_0.svg'/> 위치"
                                placeholder="위치 선택"
                                value={tempFilter?.addr}
                                max={null}
                                regexp={null}
                                errMsg={null}
                                readOnly={true}
                                func={(value) => {
                                }}
                            />
                            <InputItemBox
                                inputType={null}
                                addClass="readOnlyNotColor"
                                inputName="<img src='/assets/images/icon/main_filter_icon_1.svg'/> 대여/반납 일시"
                                placeholder="대여/반납 일시 선택"
                                value={tempFilter?.startDtm && tempFilter?.endDtm ? `${setDateTime(tempFilter?.startDtm, "daymmddhh", null)} ~ ${setDateTime(tempFilter?.endDtm, "daymmddhh", null)}` : null}
                                max={null}
                                regexp={null}
                                errMsg={null}
                                readOnly={true}
                                func={(value) => {
                                }}
                                clickInput={() => {
                                    dateSelectPopupOpen()
                                }}
                            />
                            <InputBoxCol2>
                                <InputItemBox
                                    inputType={null}
                                    addClass=""
                                    inputName="<img src='/assets/images/icon/main_filter_icon_2.svg'/> 운전자 생년월일"
                                    placeholder="YYYY.MM.DD"
                                    value={tempFilter?.birth}
                                    max={10}
                                    regexp={/[^0-9\.]/gi}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    birthSetting={true}
                                    errMsg={null}
                                    func={(value) => {
                                        tempFilterDataCh("birth", value)
                                    }}
                                />
                                <CustomSelect
                                    addClass="absoluteSel"
                                    inputName="<img src='/assets/images/icon/main_filter_icon_3.svg'/> 운전 경력"
                                    placeholder="운전 경력 선택"
                                    value={tempFilter?.career}
                                    func={(name, val) => {
                                        tempFilterDataCh("career", val)
                                    }}
                                    disabled={false}
                                    valKey="id"
                                    nameKey="name"
                                    options={[
                                        {id: 1, name: "1년 이상"},
                                        {id: 2, name: "2년 이상"},
                                        {id: 3, name: "3년 이상"}
                                    ]}
                                />
                            </InputBoxCol2>
                            <CustomSelect
                                multiple={true}
                                basicSelText={"전체"}
                                addClass="absoluteSel"
                                inputName="<img src='/assets/images/icon/main_filter_icon_4.svg'/> 대여 희망 차종"
                                placeholder="대여 희망 차종 선택"
                                value={tempFilter?.carCategory}
                                func={(arr) => {
                                    tempFilterDataCh("carCategory", arr)
                                }}
                                disabled={false}
                                valKey="id"
                                nameKey="name"
                                options={filterTypeData ? [
                                    {id: "all", name: "전체"},
                                    ...filterTypeData
                                ] : [{id: "all", name: "전체"}]}
                            />
                        </div>
                        <BtnItem
                            addClass={`flex gradient`}
                            contents="원하는 차량 검색하기<img src='/assets/images/basic/filter_btn_move.svg'/>"
                            func={() => {
                                insurancePopupOpen()
                            }}
                        />
                    </div>
                </MainDataArea>
            </RentConditionPopup>
            <DateSelectPopup
                popupData={dateSelectPopupData}
                btnType={true}
                subBtnText={"취소"}
                subBtnFunc={() => {
                    setDateSelectPopupData(null);
                }}
                btnText={"선택 완료"}
                btnFunc={(start, end) => {
                    if (conditionPopupData) {
                        let oldData = {...tempFilter};
                        oldData.startDtm = start;
                        oldData.endDtm = end;
                        setTempFilter(oldData);
                    } else {
                        let oldData = {...filter};
                        oldData.startDtm = start;
                        oldData.endDtm = end;
                        setFilter(oldData);
                    }

                    setDateSelectPopupData(null);
                }}
            />
            <InsurancePopup
                popupData={insurancePopupData}
                data={insuranceData}
                btnType={true}
                subBtnText={"취소"}
                subBtnFunc={()=>{
                    setInsurancePopupData(null);
                }}
                btnText={"차량 검색"}
                btnFunc={(id)=>{
                    let oldData = {...tempFilter};
                    oldData.insuranceId = id;
                    oldData.insuranceName = insuranceData?.filter((el)=>el.id === oldData?.insuranceId)[0]?.name;
                    setTempFilter(oldData);
                    setFilter(oldData)

                    setConditionPopupData(null)
                    setInsurancePopupData(null);

                    setTimeout(() => {
                        navigate("/rent/list",{state: {filterData:oldData}});
                    }, 100);
                }}
            />
            <Footer pcOnly={true}/>            
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default RentReservation;